import { render } from "./BatchesReportPage.vue?vue&type=template&id=2a5b1002&scoped=true"
import script from "./BatchesReportPage.vue?vue&type=script&lang=js"
export * from "./BatchesReportPage.vue?vue&type=script&lang=js"

import "./BatchesReportPage.vue?vue&type=style&index=0&id=2a5b1002&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/fep.theismailiusa.org/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a5b1002"]])

export default __exports__